Vue.asyncComponent('ak-user-events-data', {
    props: {
        title: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        data: {
            type: String,
            required: false,
        }
    },
    data() {
        return {
            clickActive: false,
            clickOut: false,
            modalOpen: false,
        }
    },
    computed: {
        modalData() {
            return JSON.parse(this.data);
        }
    },
    methods: {
        click(e) {
            this.openModal();
            console.log('click', this.modalOpen);
        },
        setClickActive: function () {
            this.clickActive = true;

            setTimeout(() => {
                this.clickActive = false;
                this.setClickOut();
            }, 300)
        },
        setClickOut() {
            this.clickOut = true;

            setTimeout(() => {
                this.clickOut = false;
            }, 300)
        },
        /**
         * Open modal
         */
        openModal () {
            this.modalOpen = true;
        },
        /**
         * Close modal
         */
        closeModal () {
            this.modalOpen = false;
        }
    },
    filters: {
        pretty : (val, indent = 2) => {
            console.log(val, indent);
            if (typeof val === "string") {
                val = JSON.parse(val)
            }
            return JSON.stringify(val, null, indent)
        }
    },
}, 'layout/ak-user-events-data.html');
